module.exports = __webpack_public_path__ + "img/shippop_x_tqm.8c49a7fb.png";